import { StyleSheet, Font } from '@react-pdf/renderer';

import RobotoRegular from './fonts/Roboto-Regular.ttf';
import RobotoBold from './fonts/Roboto-Bold.ttf';

const BORDER_STYLE = 'solid 1px';
const BORDER_COLOR = '#666666';
const BACKGROUND_COLOR = '#e2e2e2';
const FONT_COLOR = '#505050';
const SUCCESS_COLOR = '#4dbd74';
const DANGER_COLOR = '#f86c6b';
const PRIMARY_COLOR = '#20a8d8';
const DEFAULT_COLOR = '#1e5168';
const COLOR_DARK_BLUE = '#022A5C';
const COLOR_BLACK = '#000000';
const COLOR_DEFAULT_BLACK = '#212121';

Font.register({
  family: 'Roboto-Regular',
  fonts: [
    {
      src: RobotoRegular,
      fontWeight: '400'
    }
  ]
});

Font.register({
  family: 'Roboto-Bold',
  fonts: [
    {
      src: RobotoBold,
      fontWeight: '700'
    }
  ]
});

export const styles = StyleSheet.create({
  fontSize20: {
    fontSize: 20
  },
  fontSize15: {
    fontSize: 15
  },
  fontSize13: {
    fontSize: 13
  },
  fontSize11: {
    fontSize: 11
  },
  fontSize9: {
    fontSize: 9
  },
  fontSize8: {
    fontSize: 8
  },
  fontSize6: {
    fontSize: 6.5
  },
  fontBold: {
    fontFamily: 'Roboto-Bold'
  },
  fontRegular: {
    fontFamily: 'Roboto-Regular'
  },
  fontColorGray: {
    color: FONT_COLOR
  },
  noBorderTop: {
    borderTop: 'none'
  },
  noMargin: {
    margin: 0
  },
  marginBottom5: {
    marginBottom: 5
  },
  tableCellBorderBottom: {
    borderBottomColor: BORDER_COLOR,
    borderBottomWidth: 1
  },
  colorDarkBlue : {
    color: COLOR_DARK_BLUE
  },
  colorDefaultBlack: {
    color: COLOR_DEFAULT_BLACK
  },
  colorBlack: {
    color: COLOR_BLACK
  },
  defaultColor: {
    color: DEFAULT_COLOR
  },
  secondaryColor: {
    color: '#C4C4C4'
  },
  body: {
    padding: 10
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 10
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableColHeader: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCellHeader: {
    fontFamily: 'Roboto-Bold',
    margin: 5,
    fontSize: 10,
    fontWeight: 700,
    color: FONT_COLOR
  },
  tableCell: {
    fontFamily: 'Roboto-Regular',
    margin: 5,
    fontSize: 8,
    color: FONT_COLOR
  },
  tableFinancialBlack: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: '#000000',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 10
  },
  tableFinancial: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: '#D0D0D0',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 10
  },
  tableRowFinancial: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableColHeaderFinancial: {
    paddingTop: 2.5,
    paddingBottom: 2.5,
    backgroundColor: COLOR_DARK_BLUE
  },
  tableColHeaderFinancialWhite: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000000',
    backgroundColor: '#FFFFFF',
    paddingTop: 2.5,
    paddingBottom: 2.5
  },
  tableColFinancial: {
    borderStyle: BORDER_STYLE,
    borderColor: '#D0D0D0',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCellHeaderFinancialBlack: {
    fontFamily: 'Roboto-Bold',
    margin: 5,
    fontSize: 10,
    fontWeight: 500,
    color: '#000000',
    borderColor: '#000000'
  },
  tableCellHeaderFinancial: {
    fontFamily: 'Roboto-Bold',
    margin: 5,
    fontSize: 9,
    fontWeight: 500,
    color: '#FFFFFF'
  },
  tableCellFinancialBlack: {
    fontFamily: 'Roboto-Regular',
    margin: 5,
    fontSize: 9,
    color: '#000000'
  },
  tableCellFinancial: {
    fontFamily: 'Roboto-Regular',
    margin: 5,
    fontSize: 9,
    color: '#757575'
  },
  tableCellBorderBottomFinancial: {
    borderBottomColor: '#D0D0D0',
    borderBottomWidth: 1
  },
  tableColFinancialBlack: {
    borderStyle: BORDER_STYLE,
    borderColor: '#000000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableColFinancial: {
    borderStyle: BORDER_STYLE,
    borderColor: '#D0D0D0',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  headerRow: {
    marginBottom: 10
  },
  text: {
    fontFamily: 'Roboto-Regular',
    fontSize: 10,
    marginBottom: 10,
    color: FONT_COLOR
  },
  footer: {
    display: 'table',
    width: 'auto',
    backgroundColor: BACKGROUND_COLOR,
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    paddingTop: 8,
    paddingLeft: 8
  },
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    fontWeight: '700',
    color: FONT_COLOR,
    textTransform: 'capitalize',
    marginBottom: 5
  },
  subtitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: 10,
    color: FONT_COLOR
  },
  label: {
    fontFamily: 'Roboto-Bold',
    fontSize: 10,
    fontWeight: '700',
    color: FONT_COLOR,
    marginBottom: 5
  },
  input: {
    fontFamily: 'Roboto-Regular',
    fontSize: 10,
    color: FONT_COLOR
  },
  column: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  fullBorder: {
    borderLeftWidth: 1,
    borderTopWidth: 1
  },
  flexEnd: {
    justifyContent: 'flex-end'
  },
  focusBackground: {
    backgroundColor: BACKGROUND_COLOR
  },
  cashFlowCell: {
    width: `${100 / 3}%`,
    paddingTop: 5,
    paddingLeft: 5,
    borderWidth: 3,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 1
  },
  cashFlowSuccess: {
    borderBottomColor: SUCCESS_COLOR,
    borderRightColor: BORDER_COLOR
  },
  cashFlowDanger: {
    borderBottomColor: DANGER_COLOR,
    borderRightColor: BORDER_COLOR
  },
  cashFlowPrimary: {
    borderBottomColor: PRIMARY_COLOR,
    borderRightColor: BORDER_COLOR
  },
  headerTitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    textTransform: 'capitalize',
    color: DEFAULT_COLOR
  },
  financialResumeTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 11,
    textTransform: 'capitalize',
    color: DEFAULT_COLOR
  },
  financialResumeBoxTitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: 11,
    textTransform: 'capitalize',
    color: DEFAULT_COLOR
  },
  financialResumeBoxValue: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: DEFAULT_COLOR
  },
  financialResumeSuccess: {
    padding: 10,
    textAlign: 'center',
    width: '33%',
    borderRadius: 5,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#D0D0D0',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: '#D0D0D0',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: '#D0D0D0',
    borderBottomWidth: 5,
    borderBottomStyle: 'solid',
    borderBottomColor: SUCCESS_COLOR
  },
  financialResumeDanger: {
    padding: 10,
    textAlign: 'center',
    width: '33%',
    borderRadius: 5,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#D0D0D0',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: '#D0D0D0',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: '#D0D0D0',
    borderBottomWidth: 5,
    borderBottomStyle: 'solid',
    borderBottomColor: DANGER_COLOR
  },
  financialResumePrimary: {
    padding: 10,
    textAlign: 'center',
    width: '33%',
    borderRadius: 5,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#D0D0D0',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: '#D0D0D0',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: '#D0D0D0',
    borderBottomWidth: 5,
    borderBottomStyle: 'solid',
    borderBottomColor: PRIMARY_COLOR
  },
  fontSuccess: {
    fontFamily: 'Roboto-Regular',
    color: SUCCESS_COLOR
  },
  fontDanger: {
    fontFamily: 'Roboto-Regular',
    color: DANGER_COLOR
  },
  fontPrimary: {
    fontFamily: 'Roboto-Regular',
    color: PRIMARY_COLOR
  },
  borderLeft: {
    borderLeftWidth: 1,
    borderLeftColor: BORDER_COLOR
  },
  image: {
    height: '50px',
    width: 'auto'
  },
  textCenter: {
    textAlign: 'center'
  }
});

export const colSize = size => {
  switch (size) {
    case 1: {
      return '65%';
    }
    case 2: {
      return '35%';
    }
    default: {
      return '100%';
    }
  }
}

export const tableCol = size => [
  styles.tableCol,
  {
    width: colSize(size),
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10
  }
]

export const table = [styles.table, styles.fullBorder];